export * from './panel.paths';
